<template>
  <Teleport to="body">
    <div
      v-if="systemStore.newVersionAvailable && !systemStore.maintenanceMode"
      class="fixed bottom-4 right-4 z-[1300] w-80 rounded-lg bg-white p-4 shadow-lg ring-1 ring-gray-200 dark:bg-slate-800 dark:ring-slate-700"
    >
      <div class="flex items-start gap-3">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30">
          <ArrowPathIcon class="h-5 w-5 text-blue-600 dark:text-blue-400" />
        </div>
        <div class="flex-1">
          <p class="text-sm font-medium text-gray-900 dark:text-white">
            Update available
          </p>
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            A new version of RightMessage is ready.
          </p>
          <button
            type="button"
            class="mt-3 rounded-md bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            @click="systemStore.reloadApp()"
          >
            Reload
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ArrowPathIcon } from '@heroicons/vue/24/outline'

const systemStore = useSystemStore()
</script>
